export const MAX = 'max';
export const MIN = 'min';
